import { Button, Header, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

export interface IReimportConceptsConfirmDialogProps {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ReimportConceptsConfirmDialog = (props: IReimportConceptsConfirmDialogProps) => {
  const { t } = useTranslation()

  return (
    <Modal open={props.open} data-testid='reimport-concepts-modal'>
      <Header content={t('global.reimport_concepts_dialog.title')} />
      <Modal.Content>
        <p>{t('global.reimport_concepts_dialog.description')}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button content={t('global.cancel')} icon='cancel' onClick={props.onCancel} data-testid='btn-cancel' />
        <Button content={t('global.confirm')} color='blue' onClick={props.onConfirm} data-testid='btn-confirm' />
      </Modal.Actions>
    </Modal>
  )
}
export default ReimportConceptsConfirmDialog
